import './style.less';
import placeHolderContent from '../../../../assets/dummyPages/placeHolderContent.json';

export default function($log, $stateParams, $timeout, ApiClass, UserClass, AuthClass, ProfileClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  vm.eventId = $stateParams.id;
  vm.location = $stateParams.location || false;

  vm.scormUpdate = () => {
    vm.loaded = false;
    ApiClass.eventsIdTypeTypeIdPatch(
      { id: vm.event.event_id, type: 'scormAttendee', type_id: vm.event.registration_id },
      {},
      {}
    )
      .then(() => {
        activate();
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  vm.scormAdminUpdate = () => {
    vm.loaded = false;
    ApiClass.eventsIdTypePatch({ id: vm.event.event_id, type: 'scormAttendee' }, {}, { queryParams: { manage: true } })
      .then(() => {
        activate();
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  const num = getRandomInt(0, 40);
  vm.stockImage = `https://assets.prolaera.com/img/stock-images/stock-image-${num}.jpg`;
  vm.placeHolderContent = placeHolderContent.content;

  function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive
  }

  vm.registrationCallback = () => {
    vm.loaded = false;
    $timeout(() => {
      activate();
    }, 5 * 1000);
  };

  vm.authenticationPopup = () => AuthClass.authenticationPopup();

  function openLogin() {
    if (ProfileClass.loggedIn) {
      return;
    }
    $timeout(() => {
      vm.authenticationPopup();
    }, 45000);
  }

  function activate() {
    ApiClass.eventsIdGet({ id: vm.eventId }, {}, { queryParams: { includePasses: true } })
      .then(({ data }) => {
        vm.event = data.event;
        vm.selectedEvent = vm.event.delivery_location;
        vm.otherEvents = data.otherEvents;
        vm.loaded = true;
        vm.isAdminOrTeamLeader = UserClass.admin || UserClass.team_leader;
        vm.isAdmin = UserClass.admin;

        openLogin();
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = { status: error.status, refresh: activate };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/marketplace/event/controller.js